import React, { useState } from 'react';
import { TbArrowDownLeft, TbArrowUpRight } from 'react-icons/tb';
import Button from '../Components/Form/Button';
import { useLoginContext } from '../Contexts/LoginContext';
import { useTranslation } from 'react-i18next';


const FidelityExtract = () => {

    const { user } = useLoginContext();
    const [visibleItems, setVisibleItems] = useState(5);
    const { t } = useTranslation();

    if (user?.points_extract?.length === 0) {
        return null
    };

    return (
        <div className="w-full flex flex-col gap-2">
            <h2 className="text-gray-400 text-sm px-4">{t('layout.fidelity.extract_title')}</h2>
            <div className="w-full flex flex-col gap-4 bg-gray-50/50 ring-1 ring-gray-100 rounded-xl p-2 shadow-md shadow-gray-100">

                <div className="flex flex-col w-full">
                    {/* Headers */}
                    <div className="grid grid-cols-3 text-gray-500 font-medium text-shopfood-title text-sm px-2 border-b border-gray-200 pb-2">
                        <div>{t('layout.fidelity.extract_order')}</div>
                        <div>{t('layout.fidelity.extract_date')}</div>
                        <div className="text-right">{t('layout.fidelity.extract_points')}</div>
                    </div>

                    {/* Items */}
                    <div className="flex flex-col divide-y divide-gray-100">
                        {user?.points_extract?.slice(0, visibleItems).map((item: any, index: number) => (
                            <div key={index} className="grid grid-cols-3 items-center py-1 px-2 text-sm">
                                <div className="font-bold text-shopfood-title">#{item.pedido}</div>
                                <div className="text-gray-400">
                                    {new Date(item.date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit' })}
                                </div>
                                <div className="flex items-center justify-end gap-1 text-shopfood-title font-bold">
                                    {item.type === 'credit' ? (
                                        <>
                                            <TbArrowUpRight className="text-shopfood-positive" />
                                            <span>{item.amount} <span className=' font-normal text-gray-400'>{t('layout.fidelity.points_short')}</span></span>
                                        </>
                                    ) : (
                                        <>
                                            <TbArrowDownLeft className="text-shopfood-negative" />
                                            <span>{item.amount} <span className=' font-normal text-gray-400'>{t('layout.fidelity.points_short')}</span></span>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Load More Button */}
                    {visibleItems <= user?.points_extract?.length && (
                        <div className="flex items-center gap-4 justify-center my-1 md:my-2">
                            <Button
                                gray
                                onClick={() => setVisibleItems(prev => prev + 5)}
                                disabled={visibleItems >= user?.points_extract?.length}
                                className='text-nowrap text-sm'
                            >
                                {t('layout.fidelity.extract_load_more')}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FidelityExtract;
